import type { CosmicProductType } from '@/lib/cms/cosmic/types/CosmicProductType'

type Props = {
  productData: CosmicProductType
}

export const getProductRecommendationSlugArray = ({
  productData,
}: Props): string[] | null =>
  productData.recommendedProducts
    ?.map((product) => {
      if (product) {
        return product.slug
      }

      return ''
    })
    .filter((slug) => slug !== '') || null
